import tvgConf from "@tvg/conf";

import { get } from "lodash";
import { isMobile, openExternalLink } from "@tvg/sh-utils/mobileUtils";

const parseQueryParams = (path, query) => path.split(query);

const checkQueryParams = (params) => {
  const queryParams = ["?", "#"];

  return queryParams.map((q) => params.includes(q))[1];
};

const queryParamType = (params) => {
  const queryParams = ["?", "#"];

  return queryParams.find((q) => params.includes(q));
};

const decodeURLParams = (url) => {
  const hashes = checkQueryParams(url)
    ? url
        .slice(0, url.indexOf("#"))
        .slice(url.indexOf("?") + 1)
        .split("&")
    : url.slice(url.indexOf("?") + 1).split("&");

  return hashes.reduce((params, hash) => {
    const split = hash.indexOf("=");

    if (split < 0) {
      return Object.assign(params, {
        [hash]: null
      });
    }

    const key = hash.slice(0, split);
    const val = hash.slice(split + 1);

    return Object.assign(params, { [key]: decodeURIComponent(val) });
  }, {});
};

const createStoryLocationObject = (url) => ({
  pathname: "/",
  hash: "#promos",
  search: `?promo=${url}`,
  state: {
    showBackBtn: true,
    pageOrigin: "promos"
  }
});

const createUrlLocationObject = (url) => {
  let pathname;
  let pathArray;
  let params;
  let hash = "";
  let search = "";

  const query = queryParamType(url);

  switch (query) {
    case "?":
      pathArray = parseQueryParams(url, query);
      pathname = pathArray[0];

      if (pathArray[1].includes("#")) {
        params = parseQueryParams(pathArray[1], "#");
        search = `?${params[0]}`;
        hash = `#${params[1]}`;
      } else {
        search = `?${pathArray[1]}`;
      }
      break;
    case "#":
      pathArray = parseQueryParams(url, query);
      pathname = pathArray[0];
      hash = `#${pathArray[1]}`;
      break;
    default:
      pathname = url;
  }

  return {
    pathname,
    hash,
    search
  };
};

const setInternalPath = (path) => {
  let locationObject;
  const { linktype } = path;
  const url = linktype === "story" ? path.cached_url : path.url;

  if (linktype === "story") {
    locationObject = createStoryLocationObject(url);
  } else {
    locationObject = createUrlLocationObject(url);
  }

  return {
    path: locationObject,
    tag: "link"
  };
};

// Method to be removed once feature toggle newLoginExperience code is removed
const setPathEncryption = (url, code) => {
  const isAcqPath = /fdbox|fanduel(\.|-)|racing/gi.test(url);

  if (isAcqPath || url === "") {
    const currentFullPath = window.btoa(
      `/&params={"promocode":"${code.trim()}"}`
    );

    return `${tvgConf().getExternalDomain().FDRSignup}${currentFullPath}`;
  }

  return url;
};

const setExternalPath = (path, context) => {
  const { url } = path;
  const { device } = tvgConf();
  const domain = tvgConf().config(`domain.${device}`);
  const { promoType, promoCode } = context;
  const isInternal =
    url.indexOf(domain) > -1 ||
    /fdbox|(?<!sportsbook\.)fanduel(\.|-)|racing/gi.test(url);
  const target = isInternal ? "_self" : "_blank";

  // Starts - This feature toggle is to support the release the new login FDR service (FDR-1027)
  const newLoginExperience = get(
    window,
    "__PRELOADED_STATE__.capi.featureToggles.newLoginExperience",
    false
  );
  if (!newLoginExperience) {
    const finalUrl =
      promoType === "acq" ? setPathEncryption(url, promoCode) : url;

    return {
      url: finalUrl,
      tag: "a",
      target
    };
  }
  // Ends - Feature toggle

  return {
    url,
    tag: "a",
    target
  };
};

const handleExternalAppPath = (event, linkType, url, target) => {
  if (
    isMobile(tvgConf().product) &&
    linkType === "url" &&
    target === "_blank"
  ) {
    event.preventDefault();
    event.stopPropagation();

    openExternalLink(url);
  }
};

export default {
  decodeURLParams,
  handleExternalAppPath,
  setExternalPath,
  setInternalPath
};
